import React from 'react';
import styles from './AdminPanelGuide.module.css';

const AdminPanelGuide = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Navigating the Admin Panel</h2>

      <div className={styles.section}>
        <h4 className={styles.subheading}>Search & Filters</h4>
        <ul className={styles.list}>
          <li>Search Bar: Quickly find data or agents.</li>
          <li>User Profile: View or edit your profile.</li>
          <li>Date Filter (Month): Select the time range to filter dashboard data.</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h4 className={styles.subheading}>Key Performance Metrics</h4>
        <ul className={styles.list}>
          <li>Total Calls – Total number of calls handled.</li>
          <li>Missed Calls – Number of calls not answered.</li>
          <li>Average Call Duration – The average length of calls.</li>
          <li>Success Rate – Percentage of calls successfully completed.</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h4 className={styles.subheading}>Agent Management</h4>
        <ul className={styles.list}>
          <li>Name: Agent’s name.</li>
          <li>Status: Active or Inactive.</li>
          <li>Agent Type: Role (Support, Supervisor, Virtual).</li>
          <li>Select Agent: Drop-down to assign/select.</li>
          <li>Action: Use to update or remove agents.</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h4 className={styles.subheading}>Assigned Phone Numbers</h4>
        <ul className={styles.list}>
          <li>Phone Number: Assigned contact number.</li>
          <li>Country: Country of the phone number.</li>
          <li>Status: Active/Inactive (Green/Red indicator).</li>
          <li>Assigned To: Agent name handling that number.</li>
          <li>Price per Minute: Rate of call charges.</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminPanelGuide;
